/**
 * @voltxampere/ui — NE5532 dual audio-grade op-amp variant (Sprint 39-3)
 *
 * Canonical low-noise studio audio op-amp. 100 V/mV open-loop gain,
 * 10 MHz GBW, 9 V/μs slew, 5 nV/√Hz input noise, 0.0005 % THD at 1 kHz.
 *
 * Reference: TI SLOS075M.
 *
 * Engine zero-diff invariant honored.
 *
 * Copyright © 2026 360 Studio
 * Licensed under MIT (see LICENSE file in repo root)
 */
import { opAmp } from "../op-amp.js";
export const opampNe5532 = {
    id: "ne5532",
    nameTr: "NE5532 (Ses-Sınıfı, DIP-8)",
    nameEn: "NE5532 (Audio-Grade, DIP-8)",
    shortcut: "O",
    category: "active",
    viewBox: opAmp.viewBox,
    terminals: opAmp.terminals,
    defaultLabel: "U",
    defaultValue: "NE5532",
    schemaType: "opamp",
    defaultParams: {
        openLoopGain: 1e5,
        saturationVoltage: 13,
        gainBandwidthProduct: 1e7,
    },
    renderSVG: () => opAmp.renderSVG(),
};
//# sourceMappingURL=opamp-ne5532.js.map